import { Routes } from '@angular/router';
import { CotizacionPausaInactivoComponent } from './components/cotizacion-pausa-inactivo/cotizacion-pausa-inactivo.component';
import { CotizacionPausaComponent } from './components/cotizacion-pausa/cotizacion-pausa/cotizacion-pausa.component';
import { CreaLeadComponent } from './components/crea_lead/crea-lead/crea-lead.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { FeedbackSimpleComponent } from './components/feedbackSimple/feedback-simple/feedback-simple.component';
import { LeadErradoComponent } from './components/lead-errado/lead-errado.component';
import { LoaderMotoComponent } from './components/loader-moto/loader-moto.component';
import { LoaderComponent } from './components/loader/loader.component';
import { NoPreparadosComponent } from './components/no_preparados/no-preparados/no-preparados.component';
import { NoEsSoatComponent } from './components/NoEsSoat/no-es-soat/no-es-soat.component';
import { PagoAprobadoComponent } from './components/pago-aprobado/pago-aprobado.component';
import { PagoRechazadoComponent } from './components/pago-rechazado/pago-rechazado.component';
import { PolizaActivaComponent } from './components/poliza-activa/poliza-activa.component';
import { ProcesandoPagoComponent } from './components/procesando-pago/procesando-pago.component';
import { ResumenCompraComponent } from './components/resumen_compra/resumen-compra/resumen-compra.component';
import { SinZonaComponent } from './components/sin-zona/sin-zona.component';
import { TiempoInactivoComponent } from './components/tiempo-inactivo/tiempo-inactivo.component';
import { CotizadorComponent } from './movilidad/pages/cotizador/cotizador.component';

import {
  CONSULTA_RUNT,
  COTIZACION_PAUSA,
  COTIZACION_PAUSA_INACTIVO,
  CREAR_LEAD,
  DATOS_RESTANTES,
  FACTURAS_PENDIENTES,
  FEEDBACK,
  FINAL_PAGE,
  LEAD_ERRADO,
  LOADER,
  LOADER_MOTO,
  NO_ES_SOAT,
  NO_PREPARADOS,
  NO_SOAT,
  ONEROSO,
  PAGO_APROBADO,
  PAGO_APROBADO_NO_AP,
  PAGO_RECHAZADO,
  PLANES,
  POLIZA_ACTIVA,
  PROCESANDO_PAGO,
  RESUMEN_COMPRA,
  RETOMA_DUPLICADO,
  SIN_ZONA,
  TIEMPO_INACTIVO,
  YATEMENOSDATOS,
} from '../app/routes.constans';
import { InfoMensajeComponent } from './components/info-mensaje/info-mensaje.component';
import { PagoAprobadoNoApComponent } from './components/pago-aprobado-no-ap/pago-aprobado-no-ap.component';
import { leadResumeGuard } from './guards/lead-resume.guard';
import { ConsultaRuntComponent } from './movilidad/pages/consulta-runt/consulta-runt.component';
import { DatosRestantesComponent } from './movilidad/pages/datos-restantes/datos-restantes.component';
import { PlanesComponent } from './movilidad/pages/planes/planes.component';
import { finalPagesChildrenRoutes } from './shared/final-pages/final-pages.routes';
import { RetomaDuplicadoComponent } from './shared/final-pages/retoma-duplicado/retoma-duplicado.component';
import { pendingInviocesGuard } from './shared/guards/pending-invoices.guard';
import { onerousChildrenRoutes } from './shared/onerous/onerous-pages.routes';
import { PendingInvoicesPageComponent } from './shared/pages/pending-invoices-page/pending-invoices-page.component';

export const routes: Routes = [
  { path: LOADER, component: LoaderComponent },
  { path: LOADER_MOTO, component: LoaderMotoComponent, canActivate: [leadResumeGuard] },

  { path: LEAD_ERRADO, component: LeadErradoComponent },

  { path: NO_ES_SOAT, component: NoEsSoatComponent },

  { path: FEEDBACK, component: FeedbackComponent },

  { path: YATEMENOSDATOS, component: FeedbackSimpleComponent },

  { path: NO_PREPARADOS, component: NoPreparadosComponent },

  { path: RESUMEN_COMPRA, component: ResumenCompraComponent },

  { path: CREAR_LEAD, component: CreaLeadComponent },

  { path: COTIZACION_PAUSA, component: CotizacionPausaComponent },

  { path: COTIZACION_PAUSA_INACTIVO, component: CotizacionPausaInactivoComponent },

  { path: TIEMPO_INACTIVO, component: TiempoInactivoComponent },

  { path: PAGO_APROBADO, component: PagoAprobadoComponent },

  { path: PAGO_APROBADO_NO_AP, component: PagoAprobadoNoApComponent },

  { path: PROCESANDO_PAGO, component: ProcesandoPagoComponent },

  { path: PAGO_RECHAZADO, component: PagoRechazadoComponent },

  { path: SIN_ZONA, component: SinZonaComponent },

  { path: POLIZA_ACTIVA, component: PolizaActivaComponent },

  { path: CONSULTA_RUNT, component: ConsultaRuntComponent, canActivate: [leadResumeGuard] },
  { path: PLANES, component: PlanesComponent },
  { path: DATOS_RESTANTES, component: DatosRestantesComponent, canActivate: [leadResumeGuard] },

  // Here the routes from final-pages are expanded
  {
    path: FINAL_PAGE,
    children: finalPagesChildrenRoutes,
  },

  {
    path: NO_SOAT,
    component: InfoMensajeComponent,
  },
  {
    path: NO_SOAT,
    component: InfoMensajeComponent,
  },
  {
    path: '',
    redirectTo: '/seguros/movilidad/motos/cotizador',
    pathMatch: 'full',
  },

  {
    path: 'seguros/movilidad/motos/cotizador',
    component: CotizadorComponent,
    canActivate: [leadResumeGuard],
  },

  {
    path: FACTURAS_PENDIENTES,
    component: PendingInvoicesPageComponent,
    canActivate: [pendingInviocesGuard],
  },
  {
    path: ONEROSO,
    children: onerousChildrenRoutes,
  },
  {
    path: RETOMA_DUPLICADO,
    component: RetomaDuplicadoComponent,
  },
];
